import React, { useEffect, useRef, useState } from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { Facebook as FacebookIcon } from "@mui/icons-material";
import { LinkedIn as LinkedInIcon } from "@mui/icons-material";
import { YouTube as YouTubeIcon } from '@mui/icons-material';
import { Instagram as InstagramIcon } from '@mui/icons-material';
import "./SocialMediaAdd.scss";
import { useTranslation } from 'react-i18next';
import { t } from "i18next";
import { LOCALIZATION } from '../../utils/localization';


const SocialMediaAdd = () => {
  const { t } = useTranslation();
  const [hasAnimated, setHasAnimated] = useState(false);
  const [count1, setCount1] = useState(0);
  const [count2, setCount2] = useState(0);
  const [count3, setCount3] = useState(0);
  const [count4, setCount4] = useState(0);
  const sectionRef = useRef<HTMLDivElement>(null);

  const animateCount = (target: number, setter: (val: number) => void) => {
    let current = 0;
    const duration = 4000;
    const stepTime = 10;
    const increment = Math.ceil((target / duration) * stepTime);

    const interval = setInterval(() => {
      current += increment;
      if (current >= target) {
        current = target;
        clearInterval(interval);
      }
      setter(current);
    }, stepTime);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          animateCount(262, setCount1);
          animateCount(26, setCount2);
          animateCount(100, setCount3);
          animateCount(58, setCount4);
        }
      },
      {
        threshold: 0.5,
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [hasAnimated]);
  
  return (
    <Box className="socialMediaAddSec" ref={sectionRef}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6} md={3}>
          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            className="socialMediaList"
            component="a"
            href="https://www.facebook.com/officialtempledekho/"
            target="_blank"
          >
            <FacebookIcon />
            <Box className="socialMediaText">
              <Typography variant="h6">
                {t(LOCALIZATION?.Facebook)}
              </Typography>
              {/* <Typography component="p">
               {t(LOCALIZATION?.Chanel_for_Community)}
              </Typography> */}

              {/* Count Number */}
              {/* <Typography component="p">
                {count1}K+
              </Typography> */}
            </Box>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            className="socialMediaList"
            component="a"
            href="https://www.linkedin.com/company/temple-dekho/"
            target="_blank"
          >
            <LinkedInIcon />
            <Box className="socialMediaText">
              <Typography variant="h6">
                {t(LOCALIZATION?.Linkedin)}
              </Typography>
              {/* <Typography component="p">
                {t(LOCALIZATION?.Latest_News_Update)}
              </Typography> */}

              {/* Count Number */}
              {/* <Typography component="p">
                {count2}K+
              </Typography> */}
            </Box>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            className="socialMediaList"
            component="a"
            href="https://www.instagram.com/templedekho"
            target="_blank"
          >
            <InstagramIcon />
            <Box className="socialMediaText">
              <Typography variant="h6">
                {t(LOCALIZATION?.Instagram)}
              </Typography>
              {/* <Typography component="p">
              {t(LOCALIZATION?.Latest_News_Update)}
              </Typography> */}

              {/* Count Number */}
              {/* <Typography component="p">
                {count3}K+
              </Typography> */}
            </Box>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            className="socialMediaList bNone"
            component="a"
            href="https://www.youtube.com/@TempleDekhoOfficial/"
            target="_blank"
          >
            <YouTubeIcon />
            <Box className="socialMediaText">
              <Typography variant="h6">
               {t(LOCALIZATION?.Youtube)}
              </Typography>
              {/* <Typography component="p">
              {t(LOCALIZATION?.Latest_News_Update)}
              </Typography> */}

              {/* Count Number */}
              {/* <Typography component="p">
                {count4}K+
              </Typography> */}
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SocialMediaAdd;
